import type { EnrichBrandRequest, EnrichBrandResponse } from '@rock/types';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Ask rock-functions to enrich a brand from Brandfetch: with no `domain`, the server searches by the
 * brand's name and auto-applies only an exact match (returning candidates otherwise); with a `domain`
 * (an admin picked a candidate), it fetches and applies that company's brand data.
 */
export async function enrichBrandFromBrandfetch(request: EnrichBrandRequest): Promise<EnrichBrandResponse> {
    const fn = httpsCallable<EnrichBrandRequest, EnrichBrandResponse>(getFunctions(), 'enrichBrandFromBrandfetch');
    const result = await fn(request);
    return result.data;
}
